import { GridHeader } from './REPORT_CONFIG';

export const DOMAIN_INFO_TEMPLATE: string =
  '<div class="domain-cont">' +
  '<div class="domain-cell">' +
  '<img class="domain-link domainIcon domainname-${domain} device-${device} region-${region} id-${indexId} section-domain-overview" src="https://www.google.com/s2/favicons?domain=${domain}&sz=48" alt="{{domain}} Favicon"/>' +
  '<div class="domain-info">' +
  '<div>' +
  '<a class="domain-link domainname-${domain} device-${device} region-${region} id-${indexId} section-domain-overview"' +
  'href="${domainInsightsLink}"' +
  'title="Domain: ${domain}</div>">' +
  '${domain}' +
  '</a>' +
  '</div>' +
  '<div class="details ${device} rating-${risk} freemium-${isFreemium}">' +
  '<i class="fa fa-desktop domain-tooltip" title="Desktop"></i><i class="fa fa-mobile-phone domain-tooltip" title="Mobile"></i>' +
  '<span class="risk-label">Risk:</span>' +
  '<span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Risk Low"/>low</span>' +
  '<span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Risk Medium"/>medium</span>' +
  '<span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Risk High"/>high</span>' +
  '<span class="risk-value freemium-lock"><i class="fa fa-lock"></i></span>' +
  '</div>' +
  '</div>' +
  '</div>' +
  '<div class="domain-details" style="top: 211.5px;">' +
  '<div class="detail-item">' +
  '<div>Registrant Email:</div>' +
  '<div>' +
  '<span class="domain-tooltip discovery-link discovery-param-registrantEmail"' +
  'title="Registrant Email: ${registrantEmail}">' +
  '${registrantEmail}' +
  '</span>' +
  '</div>' +
  '</div>' +
  '<div class="detail-item">' +
  '<div>IAB Primary Category:</div>' +
  '<div>' +
  '<span class="domain-tooltip"' +
  'title="">' +
  '${iabPrimaryCategoryList}' +
  '</span>' +
  '</div>' +
  '</div>' +
  '<div class="detail-item">' +
  '<div>IAB Sub Category:</div>' +
  '<div>' +
  '<span class="domain-tooltip"' +
  'title="">' +
  '${iabSubCategoryList}' +
  '</span>' +
  '</div>' +
  '</div>' +
  '<div class="detail-item">' +
  '<div>Top Traffic Source:</div>' +
  '<div><span class="domain-tooltip discovery-link discovery-param-trafficSource discovery-param-value-${trafficSource}" title="Traffic Source: ${trafficSource}">${trafficSource}<span></span></span></div>' +
  '</div>' +
  '<div class="detail-item detail-item-${trustedSellerId}">' +
  '<div>Trusted Seller:</div>' +
  '<div>' +
  '<span class="domain-tooltip discovery-link discovery-param-trustedSellerId discovery-param-value-${trustedSellerId}" title="Trusted Seller: ${trustedSeller}">' +
  '<img src="https://cdn.pixalate.com/sellers/icons/apn/16x16/${trustedSellerId}.jpg" width="16" height="16" alt="Seller Icon"/>&nbsp;' +
  '${trustedSeller}' +
  '</span>' +
  '</div>' +
  '</div>' +
  '<div class="detail-item">' +
  '<div>Total Sellers:</div>' +
  '<div><a class="domain-link domainname-${domain} device-${device} region-${region} id-${indexId} section-domain-sov">(${sellerCount})</a></div>' +
  '</div>' +
  '</div>';

export const DOMAIN_BRANDSAFETY_TEMPLATE =
  '<span class="rating-${brandSafetyRisk}"><span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Low"/>low</span>' +
  '<span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Icon Meter Medium"/>medium</span>' +
  '<span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Icon Meter High"/>high</span></span>';

export const DOMAIN_MFA_TEMPLATE =
  '<span class="rating-${mfaRating}"><span class="risk-value risk-low"><img src="/assets/images/icon-meter.svg" alt="Risk Low"/>low</span>' +
  '<span class="risk-value risk-medium"><img src="/assets/images/icon-meter.svg" alt="Risk Medium"/>medium</span>' +
  '<span class="risk-value risk-high"><img src="/assets/images/icon-meter.svg" alt="Risk High"/>high</span></span>';

export const DOMAIN_GRID_HEADERS: Array<GridHeader> = [
  {
    label: 'Pixalate Reach',
    key: 'pixalateReach',
    sort: 'sort-desc',
    sortColumnKey: 'pixalateReach',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Rank',
    key: 'rank',
    sort: '',
    sortColumnKey: 'rank',
    hoverKey: '',
    template:
      '<div class="big-number domain-tooltip" title="${region} Ranking">${rank}</div><div class="change-number">${rankChange}</div>',
    hidden: true,
    format: 'order'
  },
  {
    label: 'Rank Change',
    key: 'rankChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'number'
  },
  {
    label: 'Ads.txt',
    key: 'isAdsDotTxtExist',
    sort: '',
    sortColumnKey: 'isAdsDotTxtExist',
    hoverKey: '',
    template:
      '<div class="boolean ${isAdsDotTxtExist}"><i class="fa fa-check-square-o domain-tooltip" title="Enabled"></i><i class="fa fa-square-o domain-tooltip" title="Not Enabled"></i></div>',
    hidden: false,
    format: null
  },
  {
    label: 'Domain',
    key: 'domain',
    sort: '',
    sortColumnKey: 'domain',
    hoverKey: '',
    template: DOMAIN_INFO_TEMPLATE,
    hidden: false,
    format: null
  },
  {
    label: 'Inventory',
    key: 'totalInventory',
    sort: '',
    sortColumnKey: 'totalInventory',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase domain-tooltip" title="${totalInventoryRaw}"><a class="domain-link domainname-${domain} device-${device} region-${region} id-${indexId} section-domain-inventory">${totalInventory}</a></div><div class="change-number">${totalInventoryChange}</div>',
    hidden: true,
    format: 'big-number',
    tooltip:
      'The estimated number of monthly impressions this domain makes available programmatically based on the data updated weekly.'
  },
  {
    label: 'Inventory Raw',
    key: 'totalInventoryRaw',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'pretty-number'
  },
  {
    label: 'Total Inventory Change',
    key: 'totalInventoryChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'Viewability',
    key: 'nonGivtSivtViewability',
    sort: '',
    sortColumnKey: 'nonGivtSivtViewability',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase"><a class="domain-link domainname-${domain} device-${device} region-${region} id-${indexId} section-domain-viewability">${nonGivtSivtViewability}</a></div><div class="change-number">${nonGivtSivtViewabilityChange}</div>',
    hidden: false,
    format: 'percent',
    tooltip:
      'The average viewability percentage of valid traffic for all ad sizes and traffic types in the domain'
  },
  {
    label: 'Viewability Change',
    key: 'nonGivtSivtViewabilityChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'CTR',
    key: 'nonGivtSivtCtr',
    sort: '',
    sortColumnKey: 'nonGivtSivtCtr',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase"><a class="domain-link domainname-${domain} device-${device} region-${region} id-${indexId} section-domain-ctr">${nonGivtSivtCtr}</a></div><div class="change-number">${nonGivtSivtCtrChange}</div>',
    hidden: false,
    format: 'percent'
  },
  {
    label: 'CTR Change',
    key: 'nonGivtSivtCtrChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'IVT',
    key: 'givtSivtRate',
    sort: '',
    sortColumnKey: 'givtSivtRate',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase"><a class="domain-link domainname-${domain} device-${device} region-${region} id-${indexId} section-domain-ivt">${givtSivtRate}</a></div><div class="change-number">${givtSivtRateChange}</div>',
    hidden: false,
    format: 'percent',
    tooltip: 'The total percentage of non-human traffic measured on the domain'
  },
  {
    label: 'IVT Change',
    key: 'givtSivtRateChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'percent'
  },
  {
    label: 'Bid Range',
    key: 'priceBidLow',
    sort: '',
    sortColumnKey: 'priceBidLow',
    hoverKey: '',
    template:
      '<div class="big-number text-uppercase"><a class="domain-link domainname-${domain} device-${device} region-${region} id-${indexId} section-domain-details">${priceBidLow} - ${priceBidHigh}</a></div><div class="change-number">${priceBidLowChange} - ${priceBidHighChange}</div>',
    lockedInFreemium: true,
    hidden: true,
    format: 'decimal'
  },
  {
    label: 'Bid Range',
    key: 'priceBidHigh',
    sort: '',
    hoverKey: '',
    template: null,
    lockedInFreemium: true,
    hidden: true,
    format: 'decimal'
  },
  {
    label: 'Bid Range',
    key: 'priceBidLowChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'decimal'
  },
  {
    label: 'Bid Range',
    key: 'priceBidHighChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'decimal'
  },
  {
    label: 'Registrant Email',
    key: 'registrantEmail',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'IAB Primary Category',
    key: 'iabPrimaryCategoryList',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'IAB Sub Category',
    key: 'iabSubCategoryList',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Category ID',
    key: 'category',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Sub Category Name',
    key: 'subCategoryName',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Category Rank',
    key: 'categoryRank',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: 'order'
  },
  {
    label: 'Category Rank Change',
    key: 'categoryRankChange',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Traffic Source',
    key: 'trafficSource',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Seller ID',
    key: 'trustedSellerId',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Seller Name',
    key: 'trustedSeller',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Seller Count',
    key: 'sellerCount',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Device',
    key: 'device',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Region',
    key: 'region',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'Risk',
    key: 'risk',
    sort: '',
    hoverKey: '',
    template: null,
    hidden: true,
    format: null
  },
  {
    label: 'MFA Risk',
    key: 'mfaRating',
    sort: '',
    hoverKey: '',
    sortColumnKey: 'mfaRating',
    template: DOMAIN_MFA_TEMPLATE,
    hidden: false,
    format: null
  },
  {
    label: 'Brand Safety Risk',
    key: 'brandSafetyRisk',
    sort: '',
    sortColumnKey: 'brandSafetyRisk',
    hoverKey: '',
    template: DOMAIN_BRANDSAFETY_TEMPLATE,
    hidden: false,
    lockedInFreemium: false,
    format: null
  }
];
